<p>user-footbar-config works!</p>
